import { createContext, useState } from "react";
import { jsonConfig } from '../Config';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const [signed, setSigned] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')

    const [modalMsg, setModalMsg] = useState(false)
    const [msgModalMsg, setMsgModalMsg] = useState('')
    const [descModalMsg, setDescModalMsg] = useState('')
    const [titleButtonModalMsg, setTitleButtonModalMsg] = useState('Retornar')
    const [titleButtonCloseModalMsg, setTitleButtonCloseModalMsg] = useState('Fechar')
    const [perigoModalMsg, setPerigoModalMsg] = useState(false)
    const [functionModalMsg, setFunctionModalMsg] = useState(() => { })

    const [sideBar, setSideBar] = useState(false)


    const [dataEstatisticaRecuperacaoSenha, setDataEstatisticaRecuperacaoSenha] = useState([])
    const [dataRecuperacaoSenha, setDataRecuperacaoSenha] = useState([])
    const [RecuperacaoSenha, setRecuperacaoSenha] = useState({})
    const [offsetRecuperacaoSenha, setOffsetRecuperacaoSenha] = useState(0)
    const [limiteRecuperacaoSenha, setLimiteRecuperacaoSenha] = useState(jsonConfig.limitDefault)
    const [limiteBuscaRecuperacaoSenha, setLimiteBuscaRecuperacaoSenha] = useState(false)

    const [dataEstatisticaUsuarios, setDataEstatisticaUsuarios] = useState([])
    const [dataUsuarios, setDataUsuarios] = useState([])
    const [Usuarios, setUsuarios] = useState({})
    const [offsetUsuarios, setOffsetUsuarios] = useState(0)
    const [limiteUsuarios, setLimiteUsuarios] = useState(jsonConfig.limitDefault)
    const [limiteBuscaUsuarios, setLimiteBuscaUsuarios] = useState(false)
    const [modalUsuarios, setModalUsuarios] = useState(false)

    const [dataEstatisticaLogs, setDataEstatisticaLogs] = useState([])
    const [dataLogs, setDataLogs] = useState([])
    const [Logs, setLogs] = useState({})
    const [offsetLogs, setOffsetLogs] = useState(0)
    const [limiteLogs, setLimiteLogs] = useState(jsonConfig.limitDefault)
    const [limiteBuscaLogs, setLimiteBuscaLogs] = useState(false)
    const [modalLogs, setModalLogs] = useState(false)


    const [dataEstatisticaDashBoard, setDataEstatisticaDashBoard] = useState([])

    //Page, per_page, sort, sort_dir, filter

    const [page, setPage] = useState(0)
    const [per_page, setPer_page] = useState(jsonConfig.limitDefault)
    const [sort, setSort] = useState("data_criacao")
    const [sort_dir, setSort_dir] = useState("desc")
    const [filter, setFilter] = useState(null)

    const [dataEquipamentos, setDataEquipamentos] = useState([])
    const [dataEstatisticaEquipamentos, setDataEstatisticaEquipamentos] = useState([])
    const [Equipamentos, setEquipamentos] = useState({})
    const [modalEquipamentos, setModalEquipamentos] = useState(false)
    const [equipamentoHistorico, setEquipamentoHistorico] = useState([])

    const [dataEquipamentoFormato, setDataEquipamentoFormato] = useState([])
    const [dataEstatisticaEquipamentoFormato, setDataEstatisticaEquipamentoFormato] = useState([])
    const [EquipamentoFormato, setEquipamentoFormato] = useState({})
    const [modalEquipamentoFormato, setModalEquipamentoFormato] = useState(false)
    const [equipamentoFormatoHistorico, setEquipamentoFormatoHistorico] = useState([])

    const [dataMarcas, setDataMarcas] = useState([])
    const [dataEstatisticaMarcas, setDataEstatisticaMarcas] = useState([])
    const [modalMarcas, setModalMarcas] = useState(false)
    const [marcaHistorico, setMarcaHistorico] = useState([])


    const [dataEntidades, setDataEntidades] = useState([])
    const [Entidade, setEntidade] = useState({})
    const [dataEstatisticaEntidades, setDataEstatisticaEntidades] = useState([])
    const [modalEntidades, setModalEntidades] = useState(false)
    const [entidadeHistorico, setEntidadeHistorico] = useState([])

    const [dataLocalizacao, setDataLocalizacao] = useState([])
    const [dataEstatisticaLocalizacao, setDataEstatisticaLocalizacao] = useState([])
    const [modalLocalizacao, setModalLocalizacao] = useState(false)
    const [localizacaoHistorico, setLocalizacaoHistorico] = useState([])

    const [dataDepartamento, setDataDepartamento] = useState([])
    const [dataEstatisticaDepartamento, setDataEstatisticaDepartamento] = useState([])
    const [modalDepartamento, setModalDepartamento] = useState(false)
    const [departamentoHistorico, setDepartamentoHistorico] = useState([])

    const [dataFornecedores, setDataFornecedores] = useState([])
    const [dataEstatisticaFornecedores, setDataEstatisticaFornecedores] = useState([])
    const [modalFornecedores, setModalFornecedores] = useState(false)
    const [fornecedoresHistorico, setFornecedoresHistorico] = useState([])


    const [dataProdutos, setDataProdutos] = useState([])
    const [dataEstatisticaProdutos, setDataEstatisticaProdutos] = useState([])
    const [modalProdutos, setModalProdutos] = useState(false)
    const [produtosHistorico, setProdutosHistorico] = useState([])

    const [dataMovimentacoes, setDataMovimentacoes] = useState([])
    const [Movimentacao, setMovimentacao] = useState({})
    const [dataEstatisticaMovimentacoes, setDataEstatisticaMovimentacoes] = useState([])
    const [modalMovimentacoes, setModalMovimentacoes] = useState(false)
    const [movimentacoesHistorico, setMovimentacoesHistorico] = useState([])

    const [dataEstatisticaRequests, setDataEstatisticaRequests] = useState([])
    const [dataRequests, setDataRequests] = useState([])
    const [Requests, setRequests] = useState({})
    const [offsetRequests, setOffsetRequests] = useState(0)
    const [limiteRequests, setLimiteRequests] = useState(jsonConfig.limitDefault)
    const [limiteBuscaRequests, setLimiteBuscaRequests] = useState(false)
    const [modalRequests, setModalRequests] = useState(false)

    const [dataEstatisticaCamposPersonalizados, setDataEstatisticaCamposPersonalizados] = useState([])
    const [dataCamposPersonalizados, setDataCamposPersonalizados] = useState([])
    const [CamposPersonalizados, setCamposPersonalizados] = useState({})
    const [modalCamposPersonalizados, setModalCamposPersonalizados] = useState(false)
    const [camposPersonalizadosHistorico, setCamposPersonalizadosHistorico] = useState([])


    const states = {
        dataEstatisticaCamposPersonalizados,
        dataCamposPersonalizados,
        CamposPersonalizados,
        modalCamposPersonalizados,
        camposPersonalizadosHistorico,
        dataEstatisticaRequests,
        dataRequests,
        Requests,
        offsetRequests,
        limiteRequests,
        limiteBuscaRequests,
        modalRequests,
        produtosHistorico,
        movimentacoesHistorico,
        Entidade,
        fornecedoresHistorico,
        dataFornecedores,
        dataEstatisticaFornecedores,
        modalFornecedores,
        marcaHistorico,
        equipamentoHistorico,
        equipamentoFormatoHistorico,
        dataLocalizacao,
        dataEstatisticaLocalizacao,
        modalLocalizacao,
        localizacaoHistorico,
        dataDepartamento,
        dataEstatisticaDepartamento,
        modalDepartamento,
        departamentoHistorico,
        entidadeHistorico,
        dataMovimentacoes,
        Movimentacao,
        dataEstatisticaMovimentacoes,
        modalMovimentacoes,
        dataMarcas,
        dataEstatisticaMarcas,
        modalMarcas,
        dataEntidades,
        dataEstatisticaEntidades,
        modalEntidades,
        dataEstatisticaEquipamentos,
        dataEquipamentos,
        Equipamentos,
        modalEquipamentos,
        dataEquipamentoFormato,
        dataEstatisticaEquipamentoFormato,
        EquipamentoFormato,
        modalEquipamentoFormato,
        dataProdutos,
        dataEstatisticaProdutos,
        modalProdutos,
        page,
        per_page,
        sort,
        sort_dir,
        filter,
        dataEstatisticaDashBoard,
        dataEstatisticaLogs,
        dataLogs,
        Logs,
        offsetLogs,
        limiteLogs,
        limiteBuscaLogs,
        modalLogs,
        dataEstatisticaUsuarios,
        dataUsuarios,
        Usuarios,
        offsetUsuarios,
        limiteUsuarios,
        limiteBuscaUsuarios,
        modalUsuarios,
        dataEstatisticaRecuperacaoSenha,
        dataRecuperacaoSenha,
        RecuperacaoSenha,
        offsetRecuperacaoSenha,
        limiteRecuperacaoSenha,
        limiteBuscaRecuperacaoSenha,
        signed,
        isLoading,
        email,
        senha,
        modalMsg,
        msgModalMsg,
        descModalMsg,
        perigoModalMsg,
        titleButtonModalMsg,
        functionModalMsg,
        titleButtonCloseModalMsg,
        sideBar,
        isEdit
    }

    const setters = {
        setDataEstatisticaCamposPersonalizados,
        setDataCamposPersonalizados,
        setCamposPersonalizados,
        setModalCamposPersonalizados,
        setCamposPersonalizadosHistorico,
        setDataEstatisticaRequests,
        setDataRequests,
        setRequests,
        setOffsetRequests,
        setLimiteRequests,
        setLimiteBuscaRequests,
        setModalRequests,
        setProdutosHistorico,
        setMovimentacoesHistorico,
        setEntidade,
        setDataFornecedores,
        setDataEstatisticaFornecedores,
        setModalFornecedores,
        setFornecedoresHistorico,
        setMarcaHistorico,
        setEquipamentoHistorico,
        setEquipamentoFormatoHistorico,
        setDataLocalizacao,
        setDataEstatisticaLocalizacao,
        setModalLocalizacao,
        setLocalizacaoHistorico,
        setDataDepartamento,
        setDataEstatisticaDepartamento,
        setModalDepartamento,
        setDepartamentoHistorico,
        setEntidadeHistorico,
        setMovimentacao,
        setDataMovimentacoes,
        setDataEstatisticaMovimentacoes,
        setModalMovimentacoes,
        setDataMarcas,
        setDataEstatisticaMarcas,
        setModalMarcas,
        setDataEntidades,
        setDataEstatisticaEntidades,
        setModalEntidades,
        setDataEquipamentoFormato,
        setDataEstatisticaEquipamentoFormato,
        setEquipamentoFormato,
        setModalEquipamentoFormato,
        setDataEstatisticaEquipamentos,
        setDataEquipamentos,
        setEquipamentos,
        setModalEquipamentos,
        setDataProdutos,
        setDataEstatisticaProdutos,
        setModalProdutos,
        setPage,
        setPer_page,
        setSort,
        setSort_dir,
        setFilter,
        setDataEstatisticaDashBoard,
        setDataEstatisticaLogs,
        setDataLogs,
        setLogs,
        setOffsetLogs,
        setLimiteLogs,
        setLimiteBuscaLogs,
        setModalLogs,
        setDataEstatisticaUsuarios,
        setDataUsuarios,
        setUsuarios,
        setOffsetUsuarios,
        setLimiteUsuarios,
        setLimiteBuscaUsuarios,
        setModalUsuarios,
        setDataEstatisticaRecuperacaoSenha,
        setDataRecuperacaoSenha,
        setRecuperacaoSenha,
        setOffsetRecuperacaoSenha,
        setLimiteRecuperacaoSenha,
        setLimiteBuscaRecuperacaoSenha,
        setSigned,
        setIsLoading,
        setEmail,
        setSenha,
        setModalMsg,
        setMsgModalMsg,
        setDescModalMsg,
        setPerigoModalMsg,
        setTitleButtonModalMsg,
        setFunctionModalMsg,
        setTitleButtonCloseModalMsg,
        setSideBar,
        setIsEdit
    }




    return (
        <AuthContext.Provider
            value={{
                states,
                setters
            }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;
